<template>
	<div class="sidebar-page">
		<section class="sidebar-layout">
			<o-sidebar
				id="sidebar"
				position="static"
				:animate="animate"
				:mobile="mobile"
				:expand-on-hover="expandOnHover"
				:reduce="reduce"
				open
			>
				<router-link class="clipped-bottom-right" to="/status">
					<img src="/icons/orbital.svg" />
					<span>Status</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/logs">
					<img src="/icons/conversation.svg" />
					<span>Logs</span>
				</router-link>
				<!--<router-link class="clipped-bottom-right" to="/map">
					<img src="/icons/campaign.svg" />
					<span>Map</span>
				</router-link>-->
				<router-link class="clipped-bottom-right" to="/pilots">
					<img src="/icons/pilot.svg" />
					<span>Kavaliers</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/chassis">
					<img src="/icons/mech.svg" />
					<span>Chassis</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/relations">
					<img src="/icons/npc.svg" />
					<span>Relations</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/factions">
					<img src="/icons/squad.svg" />
					<span>Factions</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/baronic-record">
					<img src="/icons/license.svg" />
					<span>Lore</span>
				</router-link>
				<router-link class="clipped-bottom-right" to="/timeline">
					<img src="/icons/clockwork.svg" />
					<span>Timeline</span>
				</router-link>
				<router-link class="clipped-bottom-right terminal-link" to="/terminal">
					<img src="/faction-logos/horus.svg" />
					<span>Terminal</span>
				</router-link>
			</o-sidebar>
		</section>
	</div>
</template>

<script>
export default {
	props: {
		animate: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			expandOnHover: false,
			mobile: "reduced",
			reduce: false,
		};
	},
};
</script>

<style>
.terminal-link {
	opacity: 0;
}

[class*="animate"] .terminal-link {
	animation: terminal-flash 0.4s ease 2.5s 1 !important;
}

.terminal-link:hover,
[class*="animate"] .terminal-link:hover {
	opacity: 1 !important;
	animation: distort-sidebar 0.6s infinite !important;
}

.terminal-link img {
	visibility: hidden;
}

[class*="animate"] .terminal-link img {
	animation: terminal-flash-icon 0.4s ease 2.5s 1;
}

.terminal-link:hover img {
	visibility: visible;
	animation: distort-icon 0.6s infinite;
}

@keyframes distort-icon {
	0% {
		filter: drop-shadow(2px 1px 0 #ff00ff) drop-shadow(-2px -3px 0 #00ffff);
	}
	25% {
		filter: drop-shadow(-2px -3px 0 #ff00ff) drop-shadow(2px 1px 0 #00ffff);
	}
	50% {
		filter: drop-shadow(2px -1px 0 #ff00ff) drop-shadow(-4px 1px 0 #00ffff);
	}
	75% {
		filter: drop-shadow(-4px -1px 0 #ff00ff) drop-shadow(-2px -1px 0 #00ffff);
	}
	100% {
		filter: drop-shadow(-2px 0 0 #ff00ff) drop-shadow(2px -1px 0 #00ffff);
	}
}

@keyframes terminal-flash {
	0% {
		opacity: 0;
	}
	20% {
		opacity: 1;
		text-shadow: 2px 1px #ff00ff, -2px -3px #00ffff;
		transform: translate(-1px, 1px);
	}
	40% {
		opacity: 0;
	}
	60% {
		opacity: 0.5;
		text-shadow: -2px -3px #ff00ff, 2px 1px #00ffff;
		transform: translate(2px, -1px);
	}
	80% {
		opacity: 0;
	}
	100% {
		opacity: 0;
	}
}

@keyframes terminal-flash-icon {
	0% {
		visibility: hidden;
	}
	20% {
		visibility: visible;
		filter: drop-shadow(2px 1px 0 #ff00ff) drop-shadow(-2px -3px 0 #00ffff);
	}
	40% {
		visibility: hidden;
	}
	60% {
		visibility: visible;
		filter: drop-shadow(-2px -3px 0 #ff00ff) drop-shadow(2px 1px 0 #00ffff);
	}
	80% {
		visibility: hidden;
	}
	100% {
		visibility: hidden;
	}
}

@keyframes distort-sidebar {
	0% {
		text-shadow: 2px 1px #ff00ff, -2px -3px #00ffff;
		transform: translate(-1px, 1px);
	}
	25% {
		text-shadow: -2px -3px #ff00ff, 2px 1px #00ffff;
		transform: translate(2px, 1px);
	}
	50% {
		text-shadow: 2px -1px #ff00ff, -4px 1px #00ffff;
		transform: translate(-2px, 1px);
	}
	75% {
		text-shadow: -4px -1px #ff00ff, -2px -1px #00ffff;
		transform: translate(3px, 1px);
	}
	100% {
		text-shadow: -2px 0 #ff00ff, 2px -1px #00ffff;
		transform: translate(-2px, 0);
	}
}
</style>
